import React, {Component} from 'react';
import {Tooltip} from "antd";

class NormalTitle extends Component {
    static defaultProps = {
        width:"277px",
        dataIndex: "title"
    };
    render() {
        let {record, width, dataIndex} = this.props;
        let data = "";
        try {
            eval(`data = record.${dataIndex}`);//这里是为了避免dataIndex 为 属性中的属性，所以不能单纯的使用 record[dataIndex]
        }catch (e) {
        }
        let name = data;
        if(data && data.length > 200){
            name = (data).substring(0, 200) + "..."
        }
        return   <div style={{width,overflow: "hidden",textOverflow: "ellipsis",whiteSpace:"nowrap"}}>
            <Tooltip placement="topLeft"
                     title={<div>{data.length > 800 ? (data).substring(0, 800) + "..." : data}</div>}
                     overlayClassName="custom-tooltip">{data}</Tooltip>
            <style>{`
            .custom-tooltip {
              max-width: 600px; /* 自定义 Tooltip 的最大宽度 */
              white-space: normal; /* 允许文字换行 */
            }
            `}</style>
        </div>
    }
}

export default NormalTitle;
